import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { ApiStatus } from '../../types/api/status'
import { referenceDocument, referenceDocumentType } from '../../types/slices/referenceDocumentType'

const initialState: referenceDocumentType =
{
    status: ApiStatus.FETCHED,
    references: [],
    referenceSelected: {} as referenceDocument,
    errorMessage: undefined,
    action: ''
}

const referenceDocumentSlice = createSlice({
    name: 'referenceDocumentSlice',
    initialState,
    reducers: {
        onFetchReferences (state, { payload }: { payload: referenceDocument[]}) {
            state.status = ApiStatus.FETCHED
            state.references = payload
            state.errorMessage = undefined
        },
        onSetSelectedReference (state, { payload }: { payload: referenceDocument }) {
            state.referenceSelected = payload
        },
        changeStatus (state, { payload }: { payload: ApiStatus}){
            state.status = payload
        },
        setAction (state, { payload }: { payload: string }) {
            state.action = payload
        },
    }
})

export const selectReferenceState = (state: RootState) => state.referenceDocumentSlice
export default referenceDocumentSlice.reducer
export const {
    onFetchReferences,
    onSetSelectedReference,
    changeStatus,
    setAction,
} = referenceDocumentSlice.actions
